import React, { useEffect, useRef } from "react";

const MouseGrad = () => {
  const interBubbleRef = useRef(null);
  const curX = useRef(0);
  const curY = useRef(0);
  const tgX = useRef(0);
  const tgY = useRef(0);

  useEffect(() => {
    const move = () => {
      curX.current += (tgX.current - curX.current) / 10;
      curY.current += (tgY.current - curY.current) / 10;

      if (interBubbleRef.current) {
        interBubbleRef.current.style.transform = `translate(${Math.round(curX.current)}px, ${Math.round(curY.current)}px)`;
      }

      requestAnimationFrame(move);
    };

    const handleMouseMove = (event) => {
      tgX.current = event.clientX;
      tgY.current = event.clientY;
    };

    window.addEventListener("mousemove", handleMouseMove);
    requestAnimationFrame(move);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div className="mouse-bg">
      <div className="mouse-container">
        <div className="interactive" ref={interBubbleRef}></div>
      </div>
    </div>
  );
};

export default MouseGrad;
